import { render, staticRenderFns } from "./NewEmployee.vue?vue&type=template&id=0b219584&scoped=true&"
import script from "./NewEmployee.vue?vue&type=script&lang=js&"
export * from "./NewEmployee.vue?vue&type=script&lang=js&"
import style0 from "./NewEmployee.vue?vue&type=style&index=0&id=0b219584&scoped=true&lang=css&"
import style1 from "./NewEmployee.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b219584",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b219584')) {
      api.createRecord('0b219584', component.options)
    } else {
      api.reload('0b219584', component.options)
    }
    module.hot.accept("./NewEmployee.vue?vue&type=template&id=0b219584&scoped=true&", function () {
      api.rerender('0b219584', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Payroll/NewEmployee.vue"
export default component.exports